// Rating icons - add new rating-*.svg files and update this map manually
import ratingAuG from './rating-au-g.svg';
import ratingAuM from './rating-au-m.svg';
import ratingAuMa15Plus from './rating-au-ma-15-plus.svg';
import ratingAuPg from './rating-au-pg.svg';
import ratingAuR18Plus from './rating-au-r-18-plus.svg';
import ratingBr10 from './rating-br-10.svg';
import ratingBr12 from './rating-br-12.svg';
import ratingBr14 from './rating-br-14.svg';
import ratingBr16 from './rating-br-16.svg';
import ratingBr18 from './rating-br-18.svg';
import ratingBr6 from './rating-br-6.svg';
import ratingBrA10 from './rating-br-a10.svg';
import ratingBrA12 from './rating-br-a12.svg';
import ratingBrA14 from './rating-br-a14.svg';
import ratingBrA16 from './rating-br-a16.svg';
import ratingBrA18 from './rating-br-a18.svg';
import ratingBrA6 from './rating-br-a6.svg';
import ratingBrAl from './rating-br-al.svg';
import ratingBrL from './rating-br-l.svg';
import ratingCaG from './rating-ca-g.svg';
import ratingCaNc17 from './rating-ca-nc-17.svg';
import ratingCaPg13 from './rating-ca-pg-13.svg';
import ratingCaPg from './rating-ca-pg.svg';
import ratingCaR from './rating-ca-r.svg';
import ratingCaTv14 from './rating-ca-tv-14.svg';
import ratingCaTvG from './rating-ca-tv-g.svg';
import ratingCaTvMa from './rating-ca-tv-ma.svg';
import ratingCaTvPg from './rating-ca-tv-pg.svg';
import ratingCaTvY from './rating-ca-tv-y.svg';
import ratingCaTvY7Fv from './rating-ca-tv-y7-fv.svg';
import ratingCaTvY7 from './rating-ca-tv-y7.svg';
import ratingDe0 from './rating-de-0.svg';
import ratingDe12 from './rating-de-12.svg';
import ratingDe16 from './rating-de-16.svg';
import ratingDe18 from './rating-de-18.svg';
import ratingDe6 from './rating-de-6.svg';
import ratingFr0 from './rating-fr-0.svg';
import ratingFr12 from './rating-fr-12.svg';
import ratingFr16 from './rating-fr-16.svg';
import ratingFr18 from './rating-fr-18.svg';
import ratingFr6 from './rating-fr-6.svg';
import ratingIt0 from './rating-it-0.svg';
import ratingIt12 from './rating-it-12.svg';
import ratingIt16 from './rating-it-16.svg';
import ratingIt18 from './rating-it-18.svg';
import ratingIt6 from './rating-it-6.svg';
import ratingMxLatamG from './rating-mx-latam-g.svg';
import ratingMxLatamNc17 from './rating-mx-latam-nc-17.svg';
import ratingMxLatamPg13 from './rating-mx-latam-pg-13.svg';
import ratingMxLatamPg from './rating-mx-latam-pg.svg';
import ratingMxLatamR from './rating-mx-latam-r.svg';
import ratingMxLatamTv14 from './rating-mx-latam-tv-14.svg';
import ratingMxLatamTvG from './rating-mx-latam-tv-g.svg';
import ratingMxLatamTvMa from './rating-mx-latam-tv-ma.svg';
import ratingMxLatamTvPg from './rating-mx-latam-tv-pg.svg';
import ratingMxLatamTvY from './rating-mx-latam-tv-y.svg';
import ratingMxLatamTvY7Fv from './rating-mx-latam-tv-y7-fv.svg';
import ratingMxLatamTvY7 from './rating-mx-latam-tv-y7.svg';
import ratingUk0Plus from './rating-uk-0-plus.svg';
import ratingUk12Plus from './rating-uk-12-plus.svg';
import ratingUk15Plus from './rating-uk-15-plus.svg';
import ratingUk18Plus from './rating-uk-18-plus.svg';
import ratingUk9Plus from './rating-uk-9-plus.svg';
import ratingUkAll from './rating-uk-all.svg';

const ratingIcons = {
  'rating-au-g': ratingAuG,
  'rating-au-m': ratingAuM,
  'rating-au-ma-15-plus': ratingAuMa15Plus,
  'rating-au-pg': ratingAuPg,
  'rating-au-r-18-plus': ratingAuR18Plus,
  'rating-br-10': ratingBr10,
  'rating-br-12': ratingBr12,
  'rating-br-14': ratingBr14,
  'rating-br-16': ratingBr16,
  'rating-br-18': ratingBr18,
  'rating-br-6': ratingBr6,
  'rating-br-a10': ratingBrA10,
  'rating-br-a12': ratingBrA12,
  'rating-br-a14': ratingBrA14,
  'rating-br-a16': ratingBrA16,
  'rating-br-a18': ratingBrA18,
  'rating-br-a6': ratingBrA6,
  'rating-br-al': ratingBrAl,
  'rating-br-l': ratingBrL,
  'rating-ca-g': ratingCaG,
  'rating-ca-nc-17': ratingCaNc17,
  'rating-ca-pg-13': ratingCaPg13,
  'rating-ca-pg': ratingCaPg,
  'rating-ca-r': ratingCaR,
  'rating-ca-tv-14': ratingCaTv14,
  'rating-ca-tv-g': ratingCaTvG,
  'rating-ca-tv-ma': ratingCaTvMa,
  'rating-ca-tv-pg': ratingCaTvPg,
  'rating-ca-tv-y': ratingCaTvY,
  'rating-ca-tv-y7-fv': ratingCaTvY7Fv,
  'rating-ca-tv-y7': ratingCaTvY7,
  'rating-de-0': ratingDe0,
  'rating-de-12': ratingDe12,
  'rating-de-16': ratingDe16,
  'rating-de-18': ratingDe18,
  'rating-de-6': ratingDe6,
  'rating-fr-0': ratingFr0,
  'rating-fr-12': ratingFr12,
  'rating-fr-16': ratingFr16,
  'rating-fr-18': ratingFr18,
  'rating-fr-6': ratingFr6,
  'rating-it-0': ratingIt0,
  'rating-it-12': ratingIt12,
  'rating-it-16': ratingIt16,
  'rating-it-18': ratingIt18,
  'rating-it-6': ratingIt6,
  'rating-mx-latam-g': ratingMxLatamG,
  'rating-mx-latam-nc-17': ratingMxLatamNc17,
  'rating-mx-latam-pg-13': ratingMxLatamPg13,
  'rating-mx-latam-pg': ratingMxLatamPg,
  'rating-mx-latam-r': ratingMxLatamR,
  'rating-mx-latam-tv-14': ratingMxLatamTv14,
  'rating-mx-latam-tv-g': ratingMxLatamTvG,
  'rating-mx-latam-tv-ma': ratingMxLatamTvMa,
  'rating-mx-latam-tv-pg': ratingMxLatamTvPg,
  'rating-mx-latam-tv-y': ratingMxLatamTvY,
  'rating-mx-latam-tv-y7-fv': ratingMxLatamTvY7Fv,
  'rating-mx-latam-tv-y7': ratingMxLatamTvY7,
  'rating-uk-0-plus': ratingUk0Plus,
  'rating-uk-12-plus': ratingUk12Plus,
  'rating-uk-15-plus': ratingUk15Plus,
  'rating-uk-18-plus': ratingUk18Plus,
  'rating-uk-9-plus': ratingUk9Plus,
  'rating-uk-all': ratingUkAll,
} as const;

export default ratingIcons;

/** Full key for a rating icon. */
export type RatingIconName = keyof typeof ratingIcons;

/** @internal */
type SplitRatingKey<K extends string> = K extends `rating-mx-latam-${infer T}`
  ? { region: 'mx-latam'; token: T }
  : K extends `rating-${infer R}-${infer T}`
    ? { region: R; token: T }
    : never;

/** Structured descriptor for each rating icon key (region + token). */
export type RatingDescriptor = SplitRatingKey<RatingIconName>;

/** Region code for a parental rating icon. */
export type ParentalRatingRegion = RatingDescriptor['region'];

/** Rating token for a parental rating icon. Not every region and token combination has an icon. */
export type ParentalRatingToken = RatingDescriptor['token'];

/** Tokens valid for a given region. Use for region-scoped token autocompletion. */
export type TokensForRegion<R extends ParentalRatingRegion> = Extract<
  RatingDescriptor,
  { region: R }
>['token'];

/** Splits a rating icon key into region and token. */
export function splitRatingKey(key: RatingIconName): {
  region: ParentalRatingRegion;
  token: ParentalRatingToken;
} {
  const rest = key.slice('rating-'.length);
  if (rest.startsWith('mx-latam-')) {
    return {
      region: 'mx-latam',
      token: rest.slice('mx-latam-'.length) as ParentalRatingToken,
    };
  }
  const dashIdx = rest.indexOf('-');
  const region = rest.slice(0, dashIdx) as ParentalRatingRegion;
  const token = rest.slice(dashIdx + 1) as ParentalRatingToken;
  return { region, token };
}

/** Rating icons grouped by region. */
export type GroupedByRegion = Partial<Record<ParentalRatingRegion, ParentalRatingToken[]>>;

/** All rating icon keys grouped by region. */
export const ALL_BY_REGION: GroupedByRegion = (
  Object.keys(ratingIcons) as RatingIconName[]
).reduce<GroupedByRegion>((acc, key) => {
  const { region, token } = splitRatingKey(key);
  (acc[region] ??= []).push(token);
  return acc;
}, {});

/** One representative icon per region for storybook demos */
export const SAMPLE_ICON_PER_REGION: {
  region: ParentalRatingRegion;
  token: ParentalRatingToken;
}[] = [
  { region: 'au', token: 'ma-15-plus' },
  { region: 'uk', token: '15-plus' },
  { region: 'ca', token: 'pg' },
  { region: 'de', token: '16' },
  { region: 'fr', token: '12' },
  { region: 'it', token: '6' },
  { region: 'br', token: '14' },
  { region: 'mx-latam', token: 'pg-13' },
];
